import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { createSlice } from '@reduxjs/toolkit';
export var initialState = {
  authorization: {
    csrfToken: '',
    apiKey: '',
    accessToken: '',
    idToken: '',
    cheggBaseUrl: ''
  },
  appConstants: {
    cdnUrl: '',
    flagUrl: ''
  },
  formType: '',
  stepInvoke: false,
  defaultCountryCode: '',
  mandatoryCountries: [''],
  hiddenCountries: [''],
  regexValidation: true,
  verifyAddress: {
    city: '',
    state: '',
    countryISO: '',
    zipCode: ''
  },
  ui: {
    layout: 'full'
  },
  debug: {
    allowInvalidZipcodes: false
  },
  rioNamespace: undefined,
  inputDisabled: false
};
var configSlice = createSlice({
  name: 'config',
  initialState: initialState,
  reducers: {
    saveConfigs: function saveConfigs(state, _ref) {
      var payload = _ref.payload;
      return _objectSpread(_objectSpread({}, state), payload);
    }
  }
});
var saveConfigs = configSlice.actions.saveConfigs;
export { saveConfigs };
export default configSlice;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/user-address/dist/esm/redux/ConfigState/ConfigState.slice.js
// module id = 657
// module chunks = 11